module.exports = __webpack_public_path__ + "static/media/globe-icon.71991d27.webp";